export default (theme) => ({
  tableWrapper: {
    maxHeight: 300,
    overflow: "auto",
    margin: "10px 25px",
    borderBottom: "1px solid #fff",
  },
  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
    marginBottom: 10,
  },
  tableTitle: {},
  addButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
});
